import { baseApi } from '@klp/core/api';

import { clientApiRoutes } from './api';
import type { IKunde, KundeRequest } from './classes';

/**
 * RTK Query API for client (kunde) operations
 * Replaces the saga-based client data fetching
 */
export const clientApi = baseApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getKundeList: builder.query<Array<IKunde>, KundeRequest | undefined>({
            query: (request) => ({
                url: clientApiRoutes.getKunder(),
                params: request,
            }),
            providesTags: ['Kunde'],
        }),
    }),
});

export const { useGetKundeListQuery, useLazyGetKundeListQuery } = clientApi;
